import { ContractState } from '../../../types/ContractMessage';

export enum ContractQuickFilter {
    ALL = 'all',
    DRAFT = 'draft',
    AWARDED = 'awarded',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}

export const contractQuickFilterToState: Record<ContractQuickFilter, ContractState[] | undefined> = {
    [ContractQuickFilter.ALL]: undefined,
    [ContractQuickFilter.DRAFT]: [ContractState.DRAFT],
    [ContractQuickFilter.AWARDED]: [ContractState.AWARDED],
    [ContractQuickFilter.ACTIVE]: [ContractState.ACTIVE],
    [ContractQuickFilter.INACTIVE]: [ContractState.INACTIVE],
};

export function contractStatesToQuickFilter(states: ContractState[] | undefined): ContractQuickFilter {
    if (!states || states.length === 0) {
        return ContractQuickFilter.ALL;
    }

    if (states.length > 1) {
        return ContractQuickFilter.ALL;
    }

    return ContractQuickFilter[states[0]];
}
